import { z } from "zod";
import { EXERCISE_STATUS, LANGUAGE_CODES, VALIDATION_KEYS } from "@fysaro/shared";

// ðŸ§± El cimiento común de la estructura
const baseExerciseSchema = z.object({
  id: z.string().uuid().optional().nullable(),
  clinicId: z.string().uuid().optional().nullable(),
  description: z.string().optional().nullable(),
  exerciseCategoryId: z.string().uuid().optional().nullable(),
  zone: z.string().optional().nullable(),
  status: z.enum(EXERCISE_STATUS).optional(),
  language: z.enum(LANGUAGE_CODES as [string, ...string[]]).default("es"),
  key: z.string().optional().nullable(),
});

// ðŸŸ¢ Esquema de Creación: Forzamos lo que la plataforma necesita sí­ o sí­ para no tener ví­deos vací­os
export const createExerciseSchema = baseExerciseSchema.extend({
  name: z.string().min(1, VALIDATION_KEYS.EXERCISE.NAME_REQUIRED),
  videoUrl: z
    .string()
    .min(1, VALIDATION_KEYS.EXERCISE.URL_REQUIRED)
    .url(VALIDATION_KEYS.GENERIC.INVALID_URL),
});

// ðŸŸ¡ Esquema de Actualización: Todo pasa a ser opcional de forma nativa con .partial()
export const updateExerciseSchema = createExerciseSchema.partial();

export const createExerciseTranslationSchema = createExerciseSchema.partial();
